/**
 * Created by Bob.Gear on 11/03/14.
 */
//------------------------------------------------------------------------
//  contractTypeFilter Directive
//------------------------------------------------------------------------
angular.module("EICDataStream3.queryBuilder")
    .controller('contractTypeFilterController', ['$scope', 'lookupTables',
      function ($scope, lookupTables) {
        $scope.componentName = "contractTypeFilter";

        $scope.contractTypes = lookupTables.contractTypes();

        $scope.resetFilter = function () {
          $scope.clearContractTypeSelections();
        };

        $scope.clearContractTypeSelections = function () {
          $scope.criteria.selectedContractTypes = null;
          delete $scope.criteria["selectedContractTypes"];
        };

        $scope.removeContractTypeFilter = function () {
          $scope.resetFilter();
          $scope.$parent.removeFilter("#contractTypeFilter");
        };


        $scope.$watch("criteria.selectedContractTypes.length", function () {
          if (!$scope.criteria.selectedContractTypes) return;

          $scope.selectedCount = $scope.criteria.selectedContractTypes.length;
          $scope.plural = ($scope.selectedCount > 0) ? "" : "s";
        });

      }])
    .directive('contractTypeFilter', ['$compile',
      function ($compile) {
        return {
          replace:     true,  // replace the placeholder element with the template
          restrict:    'A',   // usage: <div projectNameFilter />
          templateUrl: "../app-ds3/search/queryBuilder/filters/contractTypeFilter.tmpl.html",

          link: function ($scope, iElement, iAttrs) {
          },

          controller: 'contractTypeFilterController'
        };
      }]);
//------------------------------------------------------------------------
